import PropTypes from 'prop-types';

export default PropTypes.shape({
  isTestingAutoplayCapabilities: PropTypes.bool,
  canAutoplayUnmuted: PropTypes.bool,
  canAutoplayMuted: PropTypes.bool,
});
